import {createUseStyles} from 'react-jss';
import {Theme} from '../../themes/default';
import bgWoodDark from "../../../assets/images/ncp/ncp_bg1.jpg";

const useBannerHomeStyles = createUseStyles((theme: Theme) => {
    return {
        title: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.latte_cream,
            textAlign: 'center',
            fontSize: 'max(5vw,5vh)',
            fontWeight: 'bold',
            '& .colorSand': {
                color: theme.colors.desert_sand_gold,
            },
            lineHeight: 1.3,
            [theme.breakpoints.down('lg')]: {
                marginTop: theme.spacing(5),
            }
        },
        subTitle: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: 'max(1.8vw,1.8vh)',
            fontWeight: 'bold',
            paddingBottom: theme.spacing(10),
            [theme.breakpoints.down('lg')]:{
                padding: theme.spacing(1),
                paddingBottom: theme.spacing(3),
                textAlign: 'center',
            }
        },
        boxWoodDark: {
            backgroundImage: `url(${bgWoodDark})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            padding: theme.spacing(8),
            alignItems: 'center',
            position: "relative",
            [theme.breakpoints.down('lg')]:{
                padding: theme.spacing(2),
            }
        },
        paddingTopNormal: {
            paddingTop: theme.spacing(5),
        },
        textGroupPrize: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            gap: theme.spacing(1/4),
        },
        textCount: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.desert_sand_gold,
            fontSize: 'max(4vw,4vh)',
            fontWeight: 'bold',
            lineHeight: 0.8,
            [theme.breakpoints.down('lg')]:{
                fontSize: 'max(5vw,5vh)',
            }
        },
        multiply: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.desert_sand_gold,
            fontSize: 'max(4vw,4vh)',
            fontWeight: 'bold',
            transform: 'rotate(45deg)',
            lineHeight: 0.8,
            [theme.breakpoints.down('lg')]:{
                fontSize: 'max(5vw,5vh)',
            }
        },
        textPrizeBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
        },
        textPrizeTitle: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.desert_sand_gold,
            fontSize: 'max(4vw,4vh)',
            fontWeight: 'bold',
            lineHeight: 0.8,
            [theme.breakpoints.down('lg')]:{
                fontSize: 'max(5vw,5vh)',
            }
        },
        textPrizeText: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.desert_sand_gold,
            fontSize: 'max(2vw,2vh)',
            fontWeight: 'bold',
            lineHeight: 1,
            letterSpacing: '1px',
            [theme.breakpoints.down('lg')]:{
                fontSize: 'max(3vw,3vh)',
            }
        },
        imgPrize: {
            height: 'auto',
            width: '100%',
            [theme.breakpoints.down('lg')]:{
                width: '60%',
            }
        },
        promotionInterval:{
            display: 'flex',
            justifyContent: "space-around",
            alignItems: 'center',
            alignContent: 'center',
            background: theme.colors.desert_sand_gold,
            padding: theme.spacing(2),
            [theme.breakpoints.down('sm')]:{
                flexDirection: 'column'
            }
        },
        button: {
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(5),
            padding: `${theme.spacing(1)} ${theme.spacing(8)}`,
            backgroundColor: theme.colors.latte_cream,
            fontFamily: theme.fonts.poplar,
            letterSpacing: '1px',
            color: theme.colors.dark_chocolate,
            fontSize: 'max(2.5vw, 2.5vh)',
            '&:hover': {
                color: theme.colors.latte_cream,
                backgroundColor: theme.colors.dark_chocolate,
            }
        },
        item: {
            display: 'flex',
            justifyContent: 'center',
            alignContent:'center',
        },
        wrapperImg: {
            display: 'flex',
            justifyContent: 'center',
            alignContent:'center',
        },
    }
});

export default useBannerHomeStyles;